var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PersonnelBox"},[_c('span',[_vm._v("发布人：")]),_c('span',[_vm._v(_vm._s(_vm.data.fbr || '无'))]),_c('span',{staticStyle:{"margin-left":"20px"}},[_vm._v("审核人：")]),_c('span',[_vm._v(_vm._s(_vm.data.shr1 || '无'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }